// src/index.js - SIMPLIFIED VERSION
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// 🔒 Disable console in production ONLY (optional)
if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
}

// Get root element
const container = document.getElementById('root');

// Create root
const root = ReactDOM.createRoot(container);

// Render app
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);